export const Spinner = {
  template: `<div class="lds-ring"><div></div><div></div><div></div><div></div></div>`
}